import { DocumentsList } from "@repo/ui";
import { type FC, useEffect, useState } from "react";
import { LoggedInBar } from "../../components/AppBar/Bars";
import { BottomNavigationDesktopComponent } from "../../components/BottomNavigation";
import { Seo } from "../../components/SEO";
import withProtection from "../../highOrderComponents/withProtection";
import { useDocuments } from "../../queryHooks";

export const AppBar: FC = () => <LoggedInBar BottomNavigationComponent={BottomNavigationDesktopComponent} />;

const Documents: FC = () => {
    const [docsEndpointErrorCode, setDocsEndpointErrorCode] = useState<number | undefined>();
    const result = useDocuments();

    useEffect(() => {
        if (result.isError) {
            const maybeError = result.error as { errorResponse?: { code?: number } } | undefined;
            setDocsEndpointErrorCode(maybeError?.errorResponse?.code);
        }
    }, [result.error, result.isError]);

    return (
        <DocumentsList
            documents={result.data}
            isLoading={result.isLoading}
            isError={result.isError}
            errorCode={docsEndpointErrorCode}
        />
    );
};

export default withProtection(Documents);

export const Head: FC = () => (
    <Seo title="Dokumenty">
        <meta name="robots" content="noindex" />
    </Seo>
);
